$(function () {
  window.isotopes = window.isotopes || [];

  square('.partner-square');

  var grid = $('main.partners').isotope({
    itemSelector: '.partner-square',
    layoutMode: 'masonry'
  })

  normalizeBackground(grid);

  $(window).on('resize',function () {
    square('.partner-square');
    setTimeout(function () {
      normalizeBackground(grid);
    },25);
    grid.isotope('layout');
  })

  window.isotopes.push(grid);
})

var unsetNormalization = function(grid) {
  $(grid).children('.hidden').remove();
}

var normalizeBackground = function(grid) {
  unsetNormalization(grid);
  var c = getElementCountPerRow(grid);

  if(c % 2 == 0) {
    $(grid).children().each(function (i,e,a) {
      if(i > 0 && i % c == 0) {
        $('<div class="partner-square hidden"></div>').insertBefore(this);
      }
    })
  }
}
